/**
 * TODO archivo de store para configurar el redux de los valores de los beneficiarios preferences con una funcion  que retorne el lista  de beneficiarios
 */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
// ** Axios Imports
import api from "@src/api/config"

export const getBeneficiariesList = createAsyncThunk("beneficiaries/getList", async (params) => {
  const response = await api.get(`api/beneficiaries/all/list`, { params })
  return {
    params,
    data: response.data.map((beneficiary) => {
      return {
        value: beneficiary.id,
        label: beneficiary.name
      }
    })
  }
})

export const beneficiariesSlice = createSlice({
  name: "beneficiaries",
  initialState: {
    data: [] // data from backend
  },
  reducers: {
    //
  },
  extraReducers: (builder) => {
    builder.addCase(getBeneficiariesList.fulfilled, (state, action) => {
      state.data = action.payload.data
    })
  }
})

export const { setBeneficiaries } = beneficiariesSlice.actions

export default beneficiariesSlice.reducer
